module.exports = __webpack_public_path__ + "static/media/budget-calc.4de81b01.png";